import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  TableFooter,
} from "@/components/ui/table";
import Paginator from "./paginator";
import { useEffect, useState } from "react";
import { ExpectedRowTypes, TableProps } from "@/common/types";

const CustomTable = ({
  columns,
  rows,
  totalPages = 0,
  selectedPage = 1,
  showPrevious = false,
  showNext = false,
  onRowClick,
  onPageChange,
}: TableProps) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const currentData: ExpectedRowTypes[] = rows;

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    onPageChange?.(page);
  };

  useEffect(() => {
    setCurrentPage(selectedPage);
  }, [selectedPage]);

  return (
    <Table>
      <TableHeader>
        <TableRow style={{ backgroundColor: "var(--secondary)" }}>
          {columns.map((column) => (
            <TableCell key={column.field}>{column.headerName}</TableCell>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {currentData.length > 0 &&
          currentData.map((row, rowIndex) => (
            <TableRow
              key={rowIndex}
              onClick={(e) => onRowClick?.(e, row)}
              className={`${
                onRowClick ? "cursor-pointer" : ""
              } hover:bg-secondary`}
            >
              {columns.map((column) => (
                <TableCell key={column.field}>
                  {column.render
                    ? column.render(row)
                    : column.field in row
                    ? (row as any)[column.field]
                    : ""}
                </TableCell>
              ))}
            </TableRow>
          ))}
        {currentData.length === 0 && (
          <TableRow>
            <TableCell colSpan={columns.length}>No data found</TableCell>
          </TableRow>
        )}
      </TableBody>
      <TableFooter>
        <Paginator
          currentPage={currentPage}
          totalPages={totalPages}
          showPrevious={showPrevious}
          showNext={showNext}
          onPageChange={handlePageChange}
        />
      </TableFooter>
    </Table>
  );
};

export default CustomTable;
